/*
 * @Author: your name
 * @Date: 2022-01-04 13:06:04
 * @LastEditTime: 2022-01-10 11:26:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \longzhu-PC\src\store\index.js
 */
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import moment from 'moment';
import {
  sensitiveword,
  getUserInfo,
  getUserfollow,
  getUserwallet,
  walletinfo,
  versioncontrol
} from '@/api/lz.js'
import URLS from '@/api/lz.js'
import {
  chatRoomAddress
} from '@/api/wyapi.js'
import router from '../router'
import {
  Message
} from 'element-ui'
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    counter: 2321321321,
    api: "http://t-api.ansongqiubo.com",
    userData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : false, // 用户信息
    isLogin: false,
    userCareData: localStorage.getItem('userCareData') ? JSON.parse(localStorage.getItem('userCareData')) :
    false, // 用户关注列表
    userMoneyData: localStorage.getItem('userMoneyData') ? JSON.parse(localStorage.getItem('userMoneyData')) :
      false, // 用户余额数据
    boxTimes: {
      type: '',
      times: ''
    },
    WordList: {
      userNamelist: [],
      videoNamelist: [],
      roomNmaelist: [],
      roomSendlist: [],
      orderNamelist: [],
      commonSendlist: [],
    },
    pageId: '',
  },
  mutations: {
    // 路由跳转
    pageRouter(state, {
      type = 1,
      query
    }) {
      if (type == 1) {
        router.push(query)
        // const neww = this.$router.resolve({path:'/', query: {rid:1,}})
        // window.open(neww.href,'_blank')
      } else {
        console.log('跳转其他页面');
      }
    },
    setCurTimes(state, v) {
      console.log('重新刷新宝箱的状态。。。。。。。。。。。。。。。。', v);
      state.boxTimes = v
    },
    userMoneyData(state, result) {
      state.userMoneyData = result;
      localStorage.setItem('userMoneyData', JSON.stringify(result));
    },
    userCareData(state, result) {
      state.userCareData = result;
      localStorage.setItem('userCareData', JSON.stringify(result));
    },

    logout(state) {
      state.userData = {};
      state.userCareData = false;
      state.userMoneyData = false
      console.log('退出登录了。。。。。');
    },
    userData(state, result) {
      state.userData = result;
      localStorage.setItem('userData', JSON.stringify(result));
    },
    // 设置当前页id
    setPageId(state, id) {
      state.pageId = id
    },
    setSensitiveWord(state, val) {
      val.map(item => {
        if (item.scene == 2 || item.scene == 1) {
          state.WordList.userNamelist = state.WordList.userNamelist.concat(item.wordList);
        }
        if (item.scene == 3 || item.scene == 1) {
          state.WordList.videoNamelist = state.WordList.videoNamelist.concat(item.wordList);
        }
        if (item.scene == 4 || item.scene == 1) {
          state.WordList.roomNmaelist = state.WordList.roomNmaelist.concat(item.wordList);
        }
        if (item.scene == 5 || item.scene == 1) {
          state.WordList.orderNamelist = state.WordList.orderNamelist.concat(item.wordList);
        }
        if (item.scene == 6 || item.scene == 1) {
          state.WordList.roomSendlist = state.WordList.roomSendlist.concat(item.wordList);
        }
        if (item.scene == 7 || item.scene == 1) {
          state.WordList.commonSendlist = state.WordList.commonSendlist.concat(item.wordList);
        }

      })
    }
  },
  actions: {
    // 获取版本相关配置
    getSettingInfo({
      state,
      commit,
    }, info) {
      return new Promise((resolve, reject) => {
        let DayTime = localStorage.getItem('DayTime');
        let nowDay = moment().format('YYYY-MM-DD');
        let userSettingInfo = localStorage.getItem('userSettingInfo');
        // 进入首页刷新
        // DayTime == nowDay || userSettingInfo
        if (false) {
          console.log('缓存中获取版本相关配置',userSettingInfo);
          resolve(JSON.parse(userSettingInfo || {}));
        } else {
          let patams = {
            "device": "",
            "channel": "",
            "grayTheme": true,
            "minimumVersion": "",
            "currentVersion": "",
            "popUp": 0,
            "popupContent": "",
            "forceUpdate": 0,
            "hideModule": "",
            "downloadUrl": "",
            "createTime": 0
          }
          // localStorage.setItem('DayTime', moment().format('YYYY-MM-DD'));
          localStorage.setItem('userSettingInfo',JSON.stringify(patams));
          resolve(patams);
          // versioncontrol({}).then(res=>{
          //   if(res.data.code == 200){
          //       let userMoneys = res.data.data;
          //       // commit('setuserSettingInfo', userMoneys);
          //       console.log('重新获取版本相关配置',userMoneys,info);
          //   }
          // })
        }
      })
    },
    // 获取宝箱状态
    setboxTimes({
      commit,
    }, info) {
      commit('setCurTimes', info)
    },
    // 获取用户余额信息
    getUserMoneyData({
      state,
      commit
    }, info) {
      return new Promise((resolve, reject) => {
        if (state.userMoneyData && info == 1) {
          console.log('缓存中获取余额', state.userMoneyData);
          resolve(state.userMoneyData);
        } else {
          walletinfo({}).then(res => {
            if (res.data.code == 200) {
              let userMoneys = res.data.data;
              commit('userMoneyData', userMoneys);
              console.log('重新获取余额数据', userMoneys, info);
              resolve(userMoneys)
            }
          })
        }
      })
    },
    // 获取用户关注的粉丝列表
    getUserFollowData({
      state,
      commit
    }, info = 1) {
      return new Promise((resolve, reject) => {
        if (state.userCareData && info == 1) {
          // console.log('缓存中获取关注列表', state.userCareData);
          resolve(state.userCareData)
        } else {
          getUserfollow({}).then(res => {
            if (res.data.code == 200) {
              if (res.data.data.today && res.data.data.later) {
                let userCareData = [...res.data.data.today, ...res.data.data.later];
                commit('userCareData', userCareData);
                // console.log('重新获取关注列表', userCareData, info);
                resolve(userCareData)
              }
            }
          })
        }
      })
    },

    // 获取登录信息
    getUserInfoData({
      state,
      commit
    }, info = 1) {
      if (localStorage.getItem('token')) {
        return new Promise((resolve, reject) => {
          console.log('开始获取用户信息', state.userData);
          if (state.userData && state.userData.userInfo && info == 1) {
            console.log('缓存中获取用户信息', state.userData);
            resolve(state.userData)
          } else {
            getUserInfo({}).then(res => {
              if (res.data.code == 200) {
                let userinfo = res.data.data;
                if (userinfo.userInfo.account == '') {
                  localStorage.clear();
                  router.replace('/')
                }
                console.log('重新获取用户数据', info, res.data.data);
                commit('userData', res.data.data);
                resolve(res.data.data)

              }
            })
          }
        })
      } else {
        console.error('未登录');
        return {}
      }
    },
    // 设置敏感词过滤
    async setWordList({
      commit,
      state
    }) {
      console.log('初始化敏感词');
      if (state.WordList && state.WordList.userNamelist.length > 0) {
        console.log('已经获取过了敏感词了');
      } else {
        let result = await sensitiveword({})
        if (result.data.code == 200 && result.data.data.length > 0) {
          commit('setSensitiveWord', result.data.data);
        }
      }


    },
    // 过滤敏感词
    async fifWord(store, data) {
      return new Promise((resolve, reject) => {
        let list = store.state.WordList[data.key];
        let stopSendStatus = true;
        list.map(item => {
          let myRe = new RegExp(item.word, "g");
          if (myRe.test(data.value)) {
            if (item.level == 1) {
              stopSendStatus = false;
              Message.error('内容包含敏感词！');
              resolve({
                state: false,
                value: '',
              })
              return
            }
            if (item.level == 2) {
              data.value = data.value.replace(myRe, '***');
            }
          }
        });
        if (stopSendStatus) {
          resolve({
            state: true,
            value: data.value,
          })
        }
      })
    },
    changePage({
      commit
    }, data) {
      commit('setPageId', data)
    },
    userData({
      state,
      commit
    }, info) {
      if (localStorage.getItem('token')) {
        axios.get(URLS.rootApi + '/v1/profile/user', {
          params: {},
          headers: {
            "device": "web",
            "packageId": "1",
            "version": "1.0.0",
            "channel": "web",
            "authToken": localStorage.getItem('token')
          }
        }).then(async (res) => {
          console.log('获取用户信息', res);
          store.commit('userData', res.data.data)
        })
      } else {
        console.warn('请登录后重试');
      }
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js